import { api_GET, api_POST, api_PUT } from "../api/_axios.js";

const contrato_api =
{
    getAll: function (concessionaria_Id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`contrato/${concessionaria_Id != null ? concessionaria_Id : ""}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getAllVigentes: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`contrato/GetAllVigentes`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    GetListFormulariosDashboard: function (contrato_Id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`contrato/GetListFormulariosDashboard/${contrato_Id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getItem: function (id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`contrato/getItem/${id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    postContrato: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`contrato/InsertContrato`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    putContrato: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`contrato/UpdateContrato`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    postContratoFase: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`contrato/InsertContratoFase`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    postContratoAditivo: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`contrato/InsertContratoAditivo`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    putContratoFase: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`contrato/UpdateContratoFase`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    configuracaoFiscalizacao: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`contrato/ConfiguracaoFiscalizacao`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
}

export default contrato_api
